// extracted by mini-css-extract-plugin
module.exports = {"ReferralsList":"ReferralsList_ReferralsList__pUxD1","Spinner":"ReferralsList_Spinner__2vSft"};